import React from 'react';
import clsx from 'clsx';
import styles from './UIGamePlayerInfoSectionImageWithCount.module.scss';
export const UIGamePlayerInfoSectionImageWithCount = ({ piece, count, size = 'md', bold })=>/*#__PURE__*/ React.createElement("div", {
        className: styles.container
    }, /*#__PURE__*/ React.createElement("img", {
        className: styles.image,
        src: piece
    }), /*#__PURE__*/ React.createElement("span", {
        className: clsx(styles.count, {
            [styles.sm]: size === 'sm',
            [styles.bold]: bold
        })
    }, count));
